/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OAuthProvider = {
    Google: 'google',
    Github: 'github',
    Bitbucket: 'bitbucket',
    Gitlab: 'gitlab',
    Facebook: 'facebook',
    Line: 'line',
    Azuread: 'azuread',
    Okta: 'okta',
    Apple: 'apple'
} as const;
export type OAuthProvider = typeof OAuthProvider[keyof typeof OAuthProvider];


export function instanceOfOAuthProvider(value: any): boolean {
    for (const key in OAuthProvider) {
        if (Object.prototype.hasOwnProperty.call(OAuthProvider, key)) {
            if (OAuthProvider[key as keyof typeof OAuthProvider] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OAuthProviderFromJSON(json: any): OAuthProvider {
    return OAuthProviderFromJSONTyped(json, false);
}

export function OAuthProviderFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthProvider {
    return json as OAuthProvider;
}

export function OAuthProviderToJSON(value?: OAuthProvider | null): any {
    return value as any;
}

export function OAuthProviderToJSONTyped(value: any, ignoreDiscriminator: boolean): OAuthProvider {
    return value as OAuthProvider;
}

